import React from 'react'
import { UilCheckCircle } from '@iconscout/react-unicons'

export default function ChecklistItem({ text, color = 'text-primary' }) {
  return (
    <li className="flex items-center gap-2 py-0.5 text-xs text-secondary">
      <UilCheckCircle size={16} className={`shrink-0 ${color}`} />
      {text}
    </li>
  )
}
